// extracted by mini-css-extract-plugin
export default {"breadcrumb":"styles_breadcrumb__gtdKB","breadcrumb_box":"styles_breadcrumb_box__zzr9G","light":"styles_light__lFg5N","dark":"styles_dark__tGqPv"};